<template>
  <div class="mcf-window">
      <div class="login-background">
        <img loading="lazy" src="../assets/fond_login.jpg">
      </div>
      <div class="login-right">
        <div class="login-form">
          <img src="../assets/logo_entier_250.png" style="width:150px;">
          <h1>Connexion</h1>
          <h2>Utiliser votre compte Macrofox</h2>
          <div class="login-input">
            <div class="login-input-icon">
              <i class="fa fa-user"></i>
            </div>
            <div class="login-input-content">
              <input type="text" v-model="email" placeholder="Nom de compte" >
            </div>
          </div>
          <div class="login-input">
            <div class="login-input-icon">
              <i class="fa fa-lock"></i>
            </div>
            <div class="login-input-content">
              <input type="password" v-model="pwd" placeholder="Mot de passe"  v-on:keyup.enter="bt_login" >
            </div>
          </div>
          <div class="login-menu">
            <div class="login-menu-recovery">
              <label>Mot de passe oublié ?</label>
            </div>
            <div class="login-menu-start">
              <button @click="bt_login">Connexion</button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import apiaccount from "../core/data/account";

export default {
  data() {
    return {
      loading:false,
      email:'',
      pwd:''
    }
  },
  created: async function(){

  },
  methods:{
    bt_login:async function(){
      var pkg = await apiaccount.login(this.email,this.pwd);
      if (pkg.code==0){
        this.$router.push({path:'/home'});
      }else{
        alert('error');
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
